import useSWRImmutable from 'swr';
import { SWRResponse } from 'swr';
import {
  omnitagFiltersRespZod,
  OmnitagFiltersResp,
} from 'packages/lib/api/omnitag/contract/omnitag-filters';
import { omnitagAPIGet } from 'packages/lib/api/omnitag/rest';
import { UNIT_TEST_FILTERS } from 'packages/omnitag/text-search/__tests__/filter-definitions.data';
import { isLocalhost } from 'packages/main/serviceWorkerRegistration';

// Useful for local debugging/testing
const USE_LOCAL_FILTER_DEFINITIONS = false;

/** All frontend filters are defined in the backend, using the OmnitagFilter schema.
 * This gives backend full control over what filters are displayed on the frontend, and what params
 * are passed back to the backend during search with filters. This API retrieves that filter list.
 */
export const useGetFiltersListAPI = (): SWRResponse<OmnitagFiltersResp> => {
  const resp = useSWRImmutable('/vision/search/filters', (url) =>
    omnitagAPIGet(url, omnitagFiltersRespZod.parse)
  );

  if (isLocalhost && USE_LOCAL_FILTER_DEFINITIONS)
    return {
      data: { filters: UNIT_TEST_FILTERS },
      isLoading: false,
      error: undefined,
      isValidating: false,
      mutate: null,
    } as unknown as SWRResponse<OmnitagFiltersResp>;

  return resp;
};
